<template>
  <div
    id="submissionSentModal"
    aria-hidden="true"
    aria-labelledby="submissionSentModal"
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">Submissão enviada com sucesso</h5>
        </div>
        <div class="modal-body">
          <p class="text-center">
            Seus dados e arquivos foram enviados. Seu envio será revisado por um
            avaliador e você receberá novas instruções em breve.
          </p>
        </div>
        <div class="modal-footer">
          <button
            aria-label="Close"
            data-bs-dismiss="modal"
            type="button"
            @click="toHome"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubmissionSentModal",

  methods: {
    toHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
/* ESTILIZAÇÃO DO MODAL */
.modal-content {
  border-radius: 10px;
  padding: 2rem;
}

.modal-header {
  border-bottom: none;
}

.modal-header,
.modal-footer {
  justify-content: center;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 0;
}

.modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.modal-footer {
  border-top: none;
}

button {
  width: 45%;
  padding: 1em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
}

button:hover {
  background-color: #5aad31;
}

p {
  margin: 0;
  font-size: 18px;
}

h5 {
  color: #004a8a;
  font-size: 24px;
}

@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .modal-footer {
    flex-direction: column;
  }
}
</style>